import { render } from "./CloseQuestion.vue?vue&type=template&id=fadf3094&scoped=true"
import script from "./CloseQuestion.vue?vue&type=script&lang=js"
export * from "./CloseQuestion.vue?vue&type=script&lang=js"

import "./CloseQuestion.vue?vue&type=style&index=0&id=fadf3094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fadf3094"]])

export default __exports__